import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAssignmentQuery } from "../../redux/features/assignments/assignmentAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import EditAssignmentForm from "../../components/EditAssignmentForm";
import usePageTitle from "../../utils/usePageTitle";

export default function EditAssignment() {
  usePageTitle("Edit Assignment");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const { assignmentId } = useParams();
  const {
    data: assignment,
    isLoading,
    isError,
    error,
  } = useGetAssignmentQuery(assignmentId);

  let content = null;
  if (isLoading) {
    content = <div className="text-center mt-6">Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div className="text-center mt-6">{error}</div>;
  }
  if (!isLoading && !isError && assignment?.id) {
    content = <EditAssignmentForm assignment={assignment} />;
  }

  return (
    <div
      style={{
        minWidth: "50%",
        position: "absolute",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="container relative"
    >
      <h2 className="text-center text-3xl font-bold text-cyan">
        Edit Assignment
      </h2>
      <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
        {content}
      </div>
    </div>
  );
}
